import BaseComponent from '../../../js/base-component'

class ImageTeaser extends BaseComponent {
  constructor(options) {
    super(options);
  }

  onInit() {
    let contentPositon = 0;
    let margintop = 12;
    let altContainer = this.element.querySelectorAll('.u-teaser-image__alt');
    let contentContainer = this.element.querySelector('.u-teaser-image__content') || '';

    if (altContainer.length && contentContainer.length) {
        altContainer.forEach(function(item, index) {
          if (item.clientHeight) {
            contentPositon = item.clientHeight;
          }
        });
        contentContainer.style.bottom = contentPositon + margintop + 'px';
    }
  }
}

export default {
  name: 'ImageTeaser',
  definition: ImageTeaser
};